export default "__VITE_ASSET__EVBRaDDs__"